import { useTranslation } from 'react-i18next';
import {
  Button,
  Modal,
  Tabs,
  IconButton,
  AvatarStack,
  PersonAvatar,
} from '@teo/components';
import {
  ArrowLeft,
  Sidebar,
  InformationFilled,
  Plus,
} from '@teo/components/icons';
import { useEffect, useState, useContext, useRef } from 'react';
import CoursestModal from './CoursestModal';
import { Userwithorganisationwithidps } from '@/models';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { config } from '@/config';
import { useGet } from '@/query/fetchHooks';
import { parseTypeCourse } from '@/util';
import { format } from 'date-fns';
import { DataTable } from '@/components/DataTable/DataTable';
import ReactDOM from 'react-dom';

const pastels = [
  '#C25FF4',
  '#E3BF00',
  '#6EC6C0',
  '#F25850',
  '#29BAFF',
  '#AE7226',
  '#1173DD',
  '#9AD055',
  '#807EFF',
  '#FF8EA4',
];

const HoverDropdownWrapper = ({ content, dropdown }: any) => {
  const anchorRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (visible && anchorRef.current) {
      const rect = anchorRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
      });
    }
  }, [visible]);

  return (
    <>
      <div
        ref={anchorRef}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        className="relative inline-block"
      >
        {content}
      </div>

      {visible &&
        ReactDOM.createPortal(
          <div
            onMouseLeave={() => setVisible(false)}
            style={{
              top: position.top,
              left: position.left,
              zIndex: 9999,
              position: 'absolute',
            }}
            className="absolute mt-2 min-w-60 divide-y divide-solid divide-grey-02 rounded-lg bg-white drop-shadow-m"
          >
            {dropdown}
          </div>,
          document.body
        )}
    </>
  );
};

function UserAddContent({
  activeCourse,
  tab,
  setOpenCouresList,
  setActiveCourse,
  setSelectCourse,
  selectCourse,
  setIsOpenAddContent,
  closeModal,
  setIsHiddenModal,
  setActiveLP,
  activeLP,
  setMembercourses,
  membercourses,
  importProgress,
}: any) {
  const { t } = useTranslation();
  const { auth } = useContext(AuthContext);
  const authUser = auth?.user as Userwithorganisationwithidps;
  const [activePublication, setActivePublication] = useState<any>();
  // const [membercourses, setMembercourses] = useState(null);

  // console.log('activeLP', activeLP)
  // console.log('tab', tab);

  useGet(`/memberlpgroupdetails`, {
    enabled: !!activeLP,
    masterId: `${activeLP},OR,learningpathId=${activeLP}`,
    organisationId: authUser.activeOrganisationId,
    lpStatus: 'active',
    onSuccess: (result: any) => {
      // console.log(2)
      if (result?.data?.length > 0) {
        setIsHiddenModal(false);
        setMembercourses(result?.data);
        return null;
      } else {
        setActiveLP(activeLP);
        setIsOpenAddContent(true);
        setIsHiddenModal(false);
        setOpenCouresList(false);
        closeModal();
      }
    },
  });

  useGet(`/membercoursedetails`, {
    enabled: !!activeCourse,
    masterId: `${activeCourse},OR,coursecontentId=${activeCourse}`,
    organisationId: authUser.activeOrganisationId,
    courseStatus: 'active',
    courseType: parseTypeCourse(tab),

    onSuccess: (result: any) => {
      // console.log(1)
      if (result?.data?.length > 0) {
        setIsHiddenModal(false);
        setMembercourses(result?.data);
        return null;
      } else {
        setActiveCourse(activeCourse);
        setIsOpenAddContent(true);
        setIsHiddenModal(false);
        setOpenCouresList(false);
        closeModal();
      }
    },
  });

  useGet(`/learningpath/${activeLP}`, {
    enabled: !!activeLP,
    onSuccess: (result: any) => {
      setActivePublication(result?.data || null);
    },
  });

  useGet(`/coursecontentdetail/${activeCourse}`, {
    enabled: !!activeCourse,
    onSuccess: (result: any) => {
      setActivePublication(result?.data || null);
    },
  });

  if (!membercourses) return null;

  return (
    <div className="w-full bg-white">
      <div className="mb-6 flex items-center border-b px-6 py-4 ">
        <IconButton
          className="mr-6"
          Icon={ArrowLeft}
          onClick={() => {
            setOpenCouresList(false);
            setSelectCourse(null);
            setActiveCourse(null);
            setActiveLP(null);
          }}
          variant="outline"
        />
        <div>
          <h4 className="mb-2 text-base">
            {t('pages.follow_up_teams.select_edition')}
          </h4>
          <p className="text-sm text-grey-06 ">
            {t('pages.follow_up_teams.select_edition_text')}
          </p>
        </div>
      </div>
      <div className="relative mx-6 max-h-[25vh] overflow-auto rounded-lg border-grey-02 sm:max-h-[35vh] sm:border">
        <DataTable
          screensUpdateTable="mobile"
          classTable="border-0"
          filter={''}
          fetch={
            activeCourse
              ? useGet.bind(null, '/membercoursedetails', {
                  masterId: `${activeCourse},OR,coursecontentId=${activeCourse}`,
                  organisationId: authUser.activeOrganisationId,
                  courseStatus: 'active',
                  courseType: parseTypeCourse(tab),
                })
              : useGet.bind(null, '/memberlpgroupdetails', {
                  masterId: `${activeLP},OR,learningpathId=${activeLP}`,
                  organisationId: authUser.activeOrganisationId,
                  lpStatus: 'active',
                })
          }
          selectableRow={{
            selected: true,
            selectedRow: selectCourse,
            setSelected: setSelectCourse,
            selectedRowColor: '!bg-secondary-01',
          }}
          defaultSort={[
            { id: 'createdAt', desc: true },
            { id: activeCourse ? 'name' : 'lpName', desc: false },
          ]}
          columns={[
            {
              title: !activeCourse
                ? t('columns.learningpath_name')
                : tab === 'assessments'
                ? t('columns.assessmentName')
                : tab === 'vacancies'
                ? t('columns.vacancyName')
                : tab === 'instructions'
                ? t('columns.instructionName')
                : t('columns.courseName'),
              id: activeCourse ? 'name' : 'lpName',
              className: 'col-start-1 col-end-8 row-start-1',
              render: (course: any) => (
                <div className="flex max-w-[220px] items-center break-all">
                  {activeCourse ? (
                    <>
                      <div className="mr-3 w-14 min-w-14 sm:w-16 sm:min-w-16">
                        <img
                          src={
                            course?.courseImage ||
                            course?.image ||
                            '/assets/images/LearnPath.png'
                          }
                          alt={course?.name}
                          className="inline h-10 w-full rounded-lg object-cover sm:h-12"
                        />
                      </div>
                      {course?.courseName || course?.name}
                    </>
                  ) : (
                    <>
                      <div className="mr-3 w-14 min-w-14 sm:w-16 sm:min-w-16">
                        <img
                          src={
                            course?.lpgroupPicture ||
                            course?.lpPicture ||
                            '/assets/images/LearnPath.png'
                          }
                          alt={course?.lpName}
                          className="inline h-10 w-full rounded-lg object-cover sm:h-12"
                        />
                      </div>
                      {course?.lpgroupName || course?.lpName}
                    </>
                  )}
                </div>
              ),
            },
            {
              addTitleOnMobile: true,
              id: 'version',
              title: t('columns.version'),
              className: 'col-start-9 col-end-10 row-start-1  justify-end',
              align: 'right',
            },
            {
              addTitleOnMobile: true,
              id: 'nrOfStudents',
              title: t('columns.students'),
              className:
                'col-start-4 col-end-7 row-start-2 justify-center text-center',
              align: 'right',
            },
            {
              addTitleOnMobile: true,
              id: 'nrOfTeams',
              title: t('columns.teams'),
              className: 'col-start-1 col-end-4 row-start-2',
              align: 'right',
              sortable: false,
              render: (course: any) => {
                return (
                  <>
                    {course?.teams?.length > 0 ? (
                      <div className="group relative inline-block">
                        <HoverDropdownWrapper
                          key={course?.id}
                          content={
                            <AvatarStack>
                              {course?.teams?.map((item: any, i: any) => (
                                <PersonAvatar
                                  key={item}
                                  id={item}
                                  name={course?.teamNames[i]}
                                  bgColor={
                                    course?.teamColors[i]
                                      ? course?.teamColors[i]
                                      : pastels[i % pastels.length]
                                  }
                                />
                              ))}
                            </AvatarStack>
                          }
                          dropdown={
                            <div className=" flex flex-col gap-3 px-4 py-3">
                              {course?.teams?.map((item: any, i: any) => (
                                <div
                                  key={item}
                                  className="flex items-center gap-3"
                                >
                                  <PersonAvatar
                                    id={item}
                                    name={course?.teamNames[i]}
                                    bgColor={
                                      course?.teamColors[i]
                                        ? course?.teamColors[i]
                                        : pastels[i % pastels.length]
                                    }
                                  ></PersonAvatar>
                                  <p className="text-[12px] font-medium text-[#231f20] sm:text-sm">
                                    {course?.teamNames[i]}
                                  </p>
                                </div>
                              ))}
                            </div>
                          }
                        />
                      </div>
                    ) : (
                      0
                    )}
                  </>
                );
              },
            },
            {
              addTitleOnMobile: true,
              className: 'col-start-8 col-end-10 row-start-2 justify-end',
              id: 'createdAt',
              title: t('columns.created'),
              render: (course: any) =>
                format(new Date(course.createdAt), 'dd/MM/yyyy'),
              align: 'right',
            },
          ]}
        />
      </div>
    </div>
  );
}

export default UserAddContent;
